var exports = {
  "k": "container__2AwYco",
};

module.exports = exports;
